<template>

    <div class="section-product-configurator">
        <Summary
            :product="product"
            :addOnsHtml='addonshtml'
            :addOns='[]'
            :totalpriceformatted='totalpriceformatted'
            :basepriceformatted='basepriceformatted'
            :startOverEnabled="false"
            :removeOptionEnabled="false"
            :enquireOptionEnabled="false"
            :viewProductEnabled="true"
        ></Summary>
    </div>
</template>

<script>

import Summary from "./product-configurator/summary";

export default {
    props: {
        product: {
            required: true
        },
        addonshtml: {
            required: false
        },
        totalpriceformatted: {
            required: false
        },
        basepriceformatted: {
            required: false
        },
    },
    components: {
        Summary
    },

}
</script>